import Advocacy from "./Advocacy";
import Campus from './Campus';
import Events from './Events';
import Healthcare from "./Healthcare";
import Hospitality from "./Hospitality";
import Other from "./Other";
import Retail from './Retail';
import Workplace from "./Workplace";

const FeatureImages = { Advocacy, Campus, Events, Healthcare, Hospitality, Other, Retail, Workplace };

export default FeatureImages;